module.exports = __webpack_public_path__ + "static/media/edit-icon.810ada2a.svg";